"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/cms_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSEventService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.event.v1.CMSEventService
 */
exports.CMSEventService = {
    typeName: "spwn.event.v1.CMSEventService",
    methods: {
        /**
         * 複数チケットの作成
         *
         * @generated from rpc spwn.event.v1.CMSEventService.CreateEventTickets
         */
        createEventTickets: {
            name: "CreateEventTickets",
            I: cms_service_pb_1.CMSEventServiceCreateEventTicketsRequest,
            O: cms_service_pb_1.CMSEventServiceCreateEventTicketsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 複数チケットの更新
         *
         * @generated from rpc spwn.event.v1.CMSEventService.UpdateEventTickets
         */
        updateEventTickets: {
            name: "UpdateEventTickets",
            I: cms_service_pb_1.CMSEventServiceUpdateEventTicketsRequest,
            O: cms_service_pb_1.CMSEventServiceUpdateEventTicketsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * チケット一覧の取得
         *
         * @generated from rpc spwn.event.v1.CMSEventService.GetEventTicketsByEventId
         */
        getEventTicketsByEventId: {
            name: "GetEventTicketsByEventId",
            I: cms_service_pb_1.CMSEventServiceGetEventTicketsByEventIdRequest,
            O: cms_service_pb_1.CMSEventServiceGetEventTicketsByEventIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントのチケット売上枚数の取得
         *
         * @generated from rpc spwn.event.v1.CMSEventService.GetEventTicketSalesByEventId
         */
        getEventTicketSalesByEventId: {
            name: "GetEventTicketSalesByEventId",
            I: cms_service_pb_1.CMSEventServiceGetEventTicketSalesByEventIdRequest,
            O: cms_service_pb_1.CMSEventServiceGetEventTicketSalesByEventIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントのチケット売上枚数の複数取得
         *
         * @generated from rpc spwn.event.v1.CMSEventService.GetOwnedEventTicketSales
         */
        getOwnedEventTicketSales: {
            name: "GetOwnedEventTicketSales",
            I: cms_service_pb_1.CMSEventServiceGetOwnedEventTicketSalesRequest,
            O: cms_service_pb_1.CMSEventServiceGetOwnedEventTicketSalesResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 一つのイベント内でのチケットの表示優先度(降順)の更新
         *
         * @generated from rpc spwn.event.v1.CMSEventService.UpdateEventTicketsPriority
         */
        updateEventTicketsPriority: {
            name: "UpdateEventTicketsPriority",
            I: cms_service_pb_1.CMSEventServiceUpdateEventTicketsPriorityRequest,
            O: cms_service_pb_1.CMSEventServiceUpdateEventTicketsPriorityResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントの保存
         *
         * @generated from rpc spwn.event.v1.CMSEventService.SaveEvent
         */
        saveEvent: {
            name: "SaveEvent",
            I: cms_service_pb_1.CMSEventServiceSaveEventRequest,
            O: cms_service_pb_1.CMSEventServiceSaveEventResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントの下書き
         *
         * @generated from rpc spwn.event.v1.CMSEventService.DraftEvent
         */
        draftEvent: {
            name: "DraftEvent",
            I: cms_service_pb_1.CMSEventServiceDraftEventRequest,
            O: cms_service_pb_1.CMSEventServiceDraftEventResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントの更新
         *
         * @generated from rpc spwn.event.v1.CMSEventService.UpdateEvent
         */
        updateEvent: {
            name: "UpdateEvent",
            I: cms_service_pb_1.CMSEventServiceUpdateEventRequest,
            O: cms_service_pb_1.CMSEventServiceUpdateEventResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントの取得
         *
         * @generated from rpc spwn.event.v1.CMSEventService.GetEvent
         */
        getEvent: {
            name: "GetEvent",
            I: cms_service_pb_1.CMSEventServiceGetEventRequest,
            O: cms_service_pb_1.CMSEventServiceGetEventResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベント一覧の取得
         *
         * @generated from rpc spwn.event.v1.CMSEventService.GetOwnedEvents
         */
        getOwnedEvents: {
            name: "GetOwnedEvents",
            I: cms_service_pb_1.CMSEventServiceGetOwnedEventsRequest,
            O: cms_service_pb_1.CMSEventServiceGetOwnedEventsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map